import React from 'react';
// import React, { useContext } from 'react';
// import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Button, Typography } from '@one-thd/sui-atomic-components';
import { useNavigate } from '@thd-olt-component-react/router';
export var ProAllowanceHeader = function (_a) {
    var proAllowacesCount = _a.proAllowacesCount, inactiveButtonStatus = _a.inactiveButtonStatus;
    var navigate = useNavigate();
    // const onExportToCSV = () => null;
    // const onPrintToPDF = () => null;
    // const { channel, isConsumerApp } = useContext(ExperienceContext);
    // const isDesktop = channel === 'desktop';
    return (React.createElement("div", { className: "sui-grid sui-gap-y-6 sui-pb-8" },
        React.createElement("div", { className: "sui-grid sui-gap-y-6 md:sui-gap-x-4 sui-grid-rows-1 md:sui-grid-rows-2 2xl:sui-grid-rows-1 sui-grid-cols-1 md:sui-grid-cols-12 lg:sui-grid-cols-9" },
            React.createElement("div", { className: "lg:sui-order-2 md:sui-col-span-5 2xl:sui-col-span-3 md:sui-col-start-8 lg:sui-col-start-6 2xl:sui-col-start-7" },
                React.createElement(Button, { onClick: function () {
                        navigate('/myaccount/proallowance/assign');
                    }, fullWidth: true, disabled: inactiveButtonStatus, "data-testid": "create-proallow-button" }, "Create New Pro Allowance")),
            React.createElement("div", { className: "sui-col-span-2 sui-order-2 md:sui-row-start-2 2xl:sui-row-start-1 md:sui-col-span-6 lg:sui-order-1" },
                React.createElement(Typography, { variant: "h2" },
                    "PRO ALLOWANCES (",
                    proAllowacesCount,
                    ")")))));
};
ProAllowanceHeader.displayName = 'ProAllowanceHeader';
